import { inject, observer } from 'mobx-react'
import React, { memo, useCallback, useEffect } from 'react'
import TableComponent from '../../../components/Common/TableComponent'
import { Empty, Pagination } from 'antd'
import { TableBottomPaginationBlock } from '../../../components/Common/Table'
import { withRouter } from 'react-router-dom'

const AssetStatisticsTable = props => {
  const {
    managementAssetWarehouseStore,
    isLoading,
    currentDate,
    handleChangeParams,
  } = props

  const {
    assetStatisticList,
    pageIndex,
    sizeIndex,
    totalCount,
  } = managementAssetWarehouseStore

  useEffect(() => {
    ;(async () => {
      await managementAssetWarehouseStore.clearFilter()
    })()
  }, [])

  const handleChangePage = useCallback(
    p => {
      const pageIndex = p - 1
      handleChangeParams({ page: p })
      managementAssetWarehouseStore.setFilter('pageIndex', pageIndex)
    },
    [managementAssetWarehouseStore]
  )

  const selectAssetStatistics = (record, type, isSameMonth) => {
    const [compareMonth] = currentDate.split('-')
    const itemLastMonth = record?.assetHistories?.filter(item => {
      const itemDate = new Date(item?.applyAt)
      return (
        item?.type === type &&
        ((isSameMonth && itemDate.getMonth() + 1 == compareMonth) ||
          (!isSameMonth && itemDate.getMonth() + 1 != compareMonth))
      )
    })
    const resultLastMonth = itemLastMonth?.length > 0 ? itemLastMonth[0] : null
    return resultLastMonth
  }

  const tableColumns = [
    {
      title: 'STT',
      width: 30,
      render: (id, record, index) => (
        <span title={pageIndex * sizeIndex + index + 1}>
          {pageIndex * sizeIndex + index + 1}
        </span>
      ),
      align: 'center',
      ellipsis: true,
    },
    {
      title: 'Tên dụng cụ, văn phòng phẩm',
      width: 150,
      render: record => {
        return <span>{record?.asset?.assetName}</span>
      },
      align: 'center',
      ellipsis: true,
    },
    {
      title: 'Đơn vị tính',
      width: 50,
      render: record => {
        return <span>{record?.asset?.assetUnitName}</span>
      },
      align: 'center',
      ellipsis: true,
    },
    {
      title: 'Thuế',
      width: 50,
      render: record => {
        const tax = record?.asset?.tax || 0
        return <span>{tax ? tax + '%' : '----'}</span>
      },
      align: 'center',
      ellipsis: true,
    },
    {
      title: 'Đơn giá trước thuế',
      width: 100,
      render: record => {
        const price =
          selectAssetStatistics(record, 'LASTMONTH', true)?.price ||
          record?.asset?.price ||
          0
        return (
          <span>
            {price ? parseFloat(price).toLocaleString('vi-VN') : '----'}
          </span>
        )
      },
      align: 'center',
      ellipsis: true,
    },
    {
      title: 'Đơn giá sau thuế',
      width: 100,
      render: record => {
        const price = record?.asset?.price || 0
        const tax = record?.asset?.tax || 0
        const totalMoney = (price * (tax + 100)) / 100 + ''
        return (
          <span>
            {totalMoney
              ? parseFloat(totalMoney).toLocaleString('vi-VN')
              : '----'}
          </span>
        )
      },
      align: 'center',
      ellipsis: true,
    },
    {
      title: 'Tồn đầu kỳ (Số lượng)',
      width: 100,
      render: record => {
        return (
          <span>
            {selectAssetStatistics(record, 'LASTMONTH', false)?.quantity || 0}
          </span>
        )
      },
      align: 'center',
      ellipsis: true,
    },
    {
      title: 'Nhập trong kỳ (Số lượng)',
      width: 100,
      render: record => {
        const periodImportQuantity = record?.assetHistories?.reduce(
          (quantity, item) => {
            if (item?.type === 'CREATE' || item?.type === 'UPDATE') {
              quantity += item.quantity
            }
            return quantity
          },
          0
        )
        return <span>{periodImportQuantity}</span>
      },
      align: 'center',
      ellipsis: true,
    },
    {
      title: 'Xuất trong kỳ (Số lượng)',
      width: 100,
      render: record => {
        const periodExportQuantity = record?.assetHistories?.reduce(
          (quantity, item) => {
            if (item?.type === 'EXPORT') {
              quantity += item.quantity
            }
            return quantity
          },
          0
        )
        return <span>{periodExportQuantity}</span>
      },
      align: 'center',
      ellipsis: true,
    },
    {
      title: 'Tồn cuối kỳ',
      children: [
        {
          title: 'Số lượng',
          width: 100,
          render: record => {
            return (
              <span>
                {selectAssetStatistics(record, 'LASTMONTH', true)?.quantity ||
                  0}
              </span>
            )
          },
          align: 'center',
          ellipsis: true,
        },
        {
          title: 'Thành tiền trước thuế',
          width: 100,
          render: record => {
            let totalMoney =
              selectAssetStatistics(record, 'LASTMONTH', true)?.preMoney || 0
            return <span>{totalMoney?.toLocaleString('vi-VN')}</span>
          },
          align: 'center',
          ellipsis: true,
        },
        {
          title: 'Thành tiền sau thuế',
          width: 100,
          render: record => {
            let totalMoneyTax =
              selectAssetStatistics(record, 'LASTMONTH', true)?.totalMoney || 0
            return <span>{totalMoneyTax?.toLocaleString('vi-VN')}</span>
          },
          align: 'center',
          ellipsis: true,
        },
      ],
    },
  ]

  return (
    <>
      <TableComponent
        scroll={{
          x: 2000,
        }}
        bordered
        // @ts-ignore
        dataSource={assetStatisticList?.data}
        // @ts-ignore
        columns={tableColumns}
        pagination={false}
        locale={{
          emptyText: (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={'Không có dữ liệu'}
            />
          ),
        }}
        loading={isLoading}
      />

      <TableBottomPaginationBlock>
        <Pagination
          current={pageIndex + 1}
          pageSize={sizeIndex}
          total={totalCount}
          showSizeChanger={false}
          onChange={handleChangePage}
        />
      </TableBottomPaginationBlock>
    </>
  )
}

export default memo(
  withRouter(
    inject('managementAssetWarehouseStore')(observer(AssetStatisticsTable))
  )
)
